import StupidDivider from "@material-ui/core/Divider"
import styled from "styled-components"

const Divider = styled(StupidDivider)`
  margin: 1em 0;
`

export default Divider
